import { ITransactionResponse } from '../models/api/search/ITransactionResponse';
import { IExecutionOptions } from '../models/query';
import { IQueryOptionsTransactions } from '../models/query/options/IQueryOptionsTransactions';
import { BaseValueCollectionQuery } from './BaseValueCollectionQuery';

export class TransactionsQuery extends BaseValueCollectionQuery<IQueryOptionsTransactions> {
	initialize(executionOptions: IExecutionOptions) {
		this.fillKeyFromQuery('id', 'idQuery', executionOptions);
	}
	getOptions(): IQueryOptionsTransactions {
		const { entityType, options = {} } = this.queryOptions;
		return {
			entityType,
			...(options.transactions || {
				entityType: 'CLSS',
			}),
		};
	}
	getRawValue<T = any>(executionOptions: IExecutionOptions): T {
		const options = this.getOptions();
		const transactionResponses: ITransactionResponse[] = this.getSubCollection(executionOptions);
		if (Array.isArray(transactionResponses)) {
			const transactions = transactionResponses.find(transactionResponse => transactionResponse.id === options.id);
			const { key } = options;
			if (key) {
				return transactions[key] as any as T;
			}
			return transactions as any as T;
		}
		return undefined;
	}
}